export class PageData {
  constructor(public current_page?: number,
              public from?: number,
              public per_page?: number,
              public total?: number,
              public ended?: boolean) {
  }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/models/page-data.model.ts